module.exports = __webpack_public_path__ + "img/administracja_inactive.309c4118.svg";